import { motion } from "framer-motion";
import { Scale } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { RESPONSABILIDADES, RESPONSABILIDADES_NOTA } from "@/lib/siteContent";
import PageHero from "@/components/site/PageHero";

const EASE = [0.16, 1, 0.3, 1];

export default function ResponsabilidadesPage() {
  useSeo(
    "Responsabilidades e Condições Técnicas | HB Solar",
    "Responsabilidades sobre fornecimento, projeto, instalação, infraestrutura elétrica, energia, conectividade, operação e manutenção de estações de recarga."
  );

  return (
    <>
      <PageHero
        testId="responsibilities-page-title"
        eyebrow="Documento técnico"
        title="Responsabilidades e Condições Técnicas"
        desc="Transparência sobre o papel de cada parte em projetos de infraestrutura de recarga para veículos elétricos."
      />

      <section className="py-20 bg-[#FAFAF9]">
        <div className="max-w-4xl mx-auto px-5 sm:px-8">
          <div data-testid="responsibilities-list" className="space-y-5">
            {RESPONSABILIDADES.map((sec, i) => (
              <motion.section
                key={sec.titulo}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: 0.03, ease: EASE }}
                className="rounded-3xl border border-slate-200/80 bg-white p-8"
              >
                <h2 className="font-display text-xl font-bold tracking-tight text-[#0B192C]">
                  <span className="mr-3 font-mono text-sm text-amber-500">{String(i + 1).padStart(2, "0")}</span>
                  {sec.titulo}
                </h2>
                <ul className="mt-4 space-y-2.5">
                  {sec.itens.map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-slate-600">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-amber-400" />
                      {item}
                    </li>
                  ))}
                </ul>
              </motion.section>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: EASE }}
            className="mt-10 flex items-start gap-4 rounded-3xl bg-[#0B192C] p-8"
          >
            <Scale className="h-7 w-7 shrink-0 text-amber-400" />
            <p className="text-sm leading-relaxed text-slate-300">{RESPONSABILIDADES_NOTA}</p>
          </motion.div>
        </div>
      </section>
    </>
  );
}
